export const itunesLink =
  "https://itunes.apple.com/us/app/gasolina-movil/id1012092962?ls=1&mt=8"
export const googlePlayLink =
  "https://play.google.com/store/apps/details?id=com.gasolinamovil.app"
export const GMFleetLink = "https://fleet.gasolinamovil.com"
